import {
  Button,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  Modal,
  Select,
  Typography,
  message,
} from "antd";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import {
  EditOutlined,
  HomeOutlined,
  CreditCardOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";

function useLazySelect(apiUrl, key, mapper, enableCache = true) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    if (enableCache && loaded) return;
    setLoading(true);
    try {
      const res = await http.get(apiUrl);
      if (res?.code === "1") {
        const list = res?.data?.[key] || res?.data || [];
        setOptions(mapper(list));
        setLoaded(true);
      } else {
        setOptions([]);
      }
    } catch (err) {
      console.error("Select load error:", err);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  return { options, loading, load };
}

const MoveModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);


  useImperativeHandle(ref, () => ({
    setModelAdd: async (record) => {
      form.resetFields();
      setVisible(true);
      if (record?.prop) {
        form.setFieldsValue({ prop: record.prop });
      }
    },
  }));

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        prop: values?.prop ?? "",
        propId: values?.propId ?? "",
      };

      const res = await http.post(`${api.getPropMove}`, payload);
      if (res?.code === "1") {
        message.success("Property Updated Successfully");
        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg || "Update failed");
      }
    } catch (err) {
      console.error(err);
      message.error(err?.msg || "Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
           MOVE PROPERTY
          </Typography.Title>
        </Flex>
      }
      width="30%"
      open={visible}
      maskClosable={false}
      destroyOnClose
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
  footer={[
  <Flex key="footer" justify="center" gap={12}>
    <Button
      onClick={() => {
        setVisible(false);
        form.resetFields();
      }}
    >
      Close
    </Button>
    <Button
      type="primary"
      loading={loading}
      onClick={() => form.submit()}
    >
      Submit
    </Button>
  </Flex>,
]}
    >
      <div className="model_top" style={{ width: "100%" }}>
         <div className="model_content">
          <Form
            form={form}
            name="updatePropertyForm"
            layout="horizontal"
            labelCol={{ style: { width: "260px" } }}
            wrapperCol={{ style: { flex: 1 } }}
            onFinish={onFinish}
          >
            <Flex align="flex-start" justify="space-between" gap={24}>
              <div style={{ flex: 1, minWidth: 420 }}>
    
               
              <Form.Item
                  name="prop"
                  label="From Property"
               >
                  <Input placeholder="City" allowClear  readOnly />
                </Form.Item>

                <Form.Item
                  name="propId"
                  label="To Property"
                  rules={[
                    { required: true, message: "Please enter Property" },
                  ]}
                >
                  <Input placeholder=" To Property " allowClear />
                </Form.Item>

           
              </div>

      
            </Flex>
          </Form>
        </div>
      </div>
    </Modal>
  );
});
export default MoveModal;
